export default {
  data_futura: 'Não é permitido data futura',
  numero_maximo: 'Não é permitido valor maior que {tamanho}',
  numero_minimo: 'Não é permitido valor menor que {tamanho}',
};
